const HOMEPAGE_TITLE = "MINAO's HOME"

const appConfigs = {
    HOMEPAGE_TITLE,
};
export default appConfigs;